export default "__VITE_ASSET__39c59f79__"